<div class="p-6 text-center">
  <h2 class="text-lg font-semibold mb-4 text-gray-800">
    Tuti nem szeretnél értesülni az új akciókról?
  </h2>
  <p class="text-gray-600 mb-6">
    Ha nem jelölöd be, akkor <strong>nem tudunk szólni</strong>, amikor a kuponod újra aktiválódik,
    vagy amikor <strong>új kedvezményt</strong> rögzítünk a QR-kódodhoz.
    <br /><br />
    Nem fogunk zargatni – havonta maximum 1 e-mailt küldünk, csak ha tényleg van újdonság.
  </p>

  <div class="flex justify-center gap-4 mt-4">
    <button
      mat-flat-button
      color="primary"
      (click)="onAccept()"
    >
      Mégis kérek értesítést
    </button>

    <button
      mat-stroked-button
      color="warn"
      (click)="onDecline()"
    >
      Nem kérek
    </button>
  </div>
</div>
